module.exports = __webpack_public_path__ + "718d4332034e9f5613db6e58febc6017.png";